export default "__VITE_ASSET__eaef3e30__"